interface MessageIdentity {
  id: string;
  messageId: number;
  sessionId: string;
  messageType: 1 | 2;
}

export interface ChatEntryFailureData {
  requestId?: string;
  sessionId?: string;
  persisted?: boolean;
  businessRejected?: boolean;
  requestTraceAvailable?: boolean;
  userMessage?: MessageIdentity;
  aiMessage?: MessageIdentity;
}

/** Use server identities only after both stores have acknowledged this exact turn. */
export function applyChatEntryFailure(
  data: ChatEntryFailureData | undefined,
  question: any,
  answer: any,
  requestId: string,
  sessionId: string,
): boolean {
  answer.entryFailure = true;
  answer.skipMessageIdLookup = true;
  if (!data?.persisted || data.requestId !== requestId || data.sessionId !== sessionId || !question) {
    return false;
  }
  const valid = (identity: MessageIdentity | undefined, type: number) =>
    identity && typeof identity.id === "string" && /^\d+$/.test(identity.id)
      && identity.sessionId === sessionId && identity.messageType === type
      && Number.isSafeInteger(identity.messageId) && identity.messageId > 0;
  if (!valid(data.userMessage, 1) || !valid(data.aiMessage, 2)) return false;
  Object.assign(question, data.userMessage, { hasReplaceId: true });
  Object.assign(answer, data.aiMessage, { hasReplaceId: true, generationStatus: "FAILED" });
  return true;
}
